import TYPES from '@/types';
import Vue from 'vue';

// Domain
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';
import Inject from '@/modules/shared/domain/di/inject';

export default class ContractSavingsActionsViewModel {
  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  readonly view!: Vue;

  readonly i18n_namespace = 'components.contract-savings';

  public constructor(view: Vue) {
    this.view = view;
  }

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  nextStep = () => {
    this.view.$emit('nextStep');
  }

  prevStep = () => {
    this.view.$emit('prevStep');
  }
}
